import request from '@/utils/request'
import { cmsServerContext } from '@/config/config'

/**
 * @author wanghui
 * @date 2018/12/4 14:25
 * 查询仪表有哪里功能类型做表头
 */
export function selectAcuFunction() {
  return request({
    url: cmsServerContext + '/acuFunction/acuFunctionList',
    method: 'get',
  })
}
/**
 * @author wanghui
 * @date 2018/12/4 15:56
 * 查询各个仪表有哪里功能类型
 */
export function selectMeterAcuFunctionType(condition) {
  return request({
    url: cmsServerContext + '/acuFunction/selectMeterAcuFunctionType',
    method: 'post',
    data: condition
  })
}